import table from './table'

const conceptualObjects =
{
    ...table,
    helmet :
    {
        title : 'Objets' ,
        metas : []
    },
    empty  : 'Aucun objet trouvé',
    search : 'Rechercher un objet ...' ,
    title  : 'Objets'
};

export default conceptualObjects ;
